import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"

export const ServiceBookingLeadTimeSchema = z
  .object({
    min: z.number().nonnegative(),
    max: z.number().nonnegative(),
    sameDayCutoffTime: z
      .string()
      .regex(/^([01]\d|2[0-3]):([0-5]\d)$/)
      .nullable()
      .optional()
      .default(null),
    blockSameDayWhenAtCapacity: z.boolean().optional().default(false),
    allowsCustomerReschedule: z.boolean().optional().default(true),
  })
  .refine(({ min, max }) => min <= max, {
    message: "common.validation.leadTimeOrder" satisfies TranslationKey,
  })

export type ServiceBookingLeadTime = z.infer<
  typeof ServiceBookingLeadTimeSchema
>
